var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDataFileBarsInfo = function SvgDataFileBarsInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "data-file-bars-info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,24c-3.722,0-6.75-3.028-6.75-6.75s3.028-6.75,6.75-6.75S24,13.528,24,17.25S20.972,24,17.25,24z M17.25,12 C14.355,12,12,14.355,12,17.25s2.355,5.25,5.25,5.25s5.25-2.355,5.25-5.25S20.145,12,17.25,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,21c-0.414,0-0.75-0.336-0.75-0.75v-3c0-0.414,0.336-0.75,0.75-0.75S18,16.836,18,17.25v3 C18,20.664,17.664,21,17.25,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,15.811c-0.62,0-1.125-0.505-1.125-1.125s0.505-1.125,1.125-1.125c0.304,0.001,0.586,0.118,0.798,0.331 c0.212,0.213,0.328,0.495,0.327,0.796C18.375,15.307,17.87,15.811,17.25,15.811z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,15C3.336,15,3,14.664,3,14.25s0.336-0.75,0.75-0.75H4.5V9.75C4.5,9.336,4.836,9,5.25,9S6,9.336,6,9.75v3.75h1.5V6.75 C7.5,6.336,7.836,6,8.25,6S9,6.336,9,6.75v7.5C9,14.664,3.75,15,3.75,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,10.5c-0.414,0-0.75-0.336-0.75-0.75v-1.5c0-0.414,0.336-0.75,0.75-0.75S12,7.836,12,8.25v1.5 C12,10.164,11.664,10.5,11.25,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25,21C1.009,21,0,19.991,0,18.75V2.25C0,1.009,1.009,0,2.25,0h10.629c0.601,0,1.165,0.234,1.59,0.658l2.872,2.872 C17.766,3.955,18,4.52,18,5.121V7.5c0,0.414-0.336,0.75-0.75,0.75S16.5,7.914,16.5,7.5V5.121c0-0.197-0.08-0.39-0.219-0.53 l-2.872-2.872c-0.142-0.141-0.33-0.219-0.53-0.219H2.25C1.836,1.5,1.5,1.836,1.5,2.25v16.5c0,0.414,0.336,0.75,0.75,0.75H7.5 c0.414,0,0.75,0.336,0.75,0.75S7.914,21,7.5,21H2.25z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDataFileBarsInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data-file-bars-info.7c69074018c4590902650b32ca5ef401.svg";